import { TimelineItemState } from 'components/generics/Timeline/index';
import classes from 'components/generics/Timeline/index.module.scss';
import React from 'react';

export interface TimelineItemStyleOptions {
  passedLineClassName?: string;
  nextLineClassName?: string;
  passedCircleClassName?: string;
  currentCircleClassName?: string;
  nextCircleClassName?: string;
  passedTitleClassName?: string;
  currentTitleClassName?: string;
  nextTitleClassName?: string;
  passedSubtitleClassName?: string;
  currentSubtitleClassName?: string;
  nextSubtitleClassName?: string;
  passedCircleIcon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  currentCircleIcon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  nextCircleIcon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  passedCircleIconClassName?: string;
  currentCircleIconClassName?: string;
  nextCircleIconClassName?: string;
}

export const getStyleTimelineItem = (
  state: TimelineItemState,
  isFirst: boolean,
  isLast: boolean,
  options?: TimelineItemStyleOptions,
  isStopStep?: boolean
) => {
  if (!options) return {};
  const {
    passedLineClassName,
    nextLineClassName,
    passedCircleClassName,
    currentCircleClassName,
    nextCircleClassName,
    passedTitleClassName,
    currentTitleClassName,
    nextTitleClassName,
    passedSubtitleClassName,
    currentSubtitleClassName,
    nextSubtitleClassName,
    passedCircleIcon,
    currentCircleIcon,
    nextCircleIcon,
    passedCircleIconClassName,
    currentCircleIconClassName,
    nextCircleIconClassName,
  } = options;

  let topLineClassName;
  let bottomLineClassName;
  let circleClassName;
  let titleClassName;
  let subtitleClassName;
  let CircleIcon;
  let circleIconClassName;

  switch (state) {
    case TimelineItemState.PASSED:
      topLineClassName = passedLineClassName;
      bottomLineClassName = passedLineClassName;
      circleClassName = passedCircleClassName;
      titleClassName = passedTitleClassName;
      subtitleClassName = passedSubtitleClassName;
      CircleIcon = passedCircleIcon;
      circleIconClassName = passedCircleIconClassName;
      break;
    case TimelineItemState.CURRENT:
      topLineClassName = passedLineClassName;
      bottomLineClassName = nextLineClassName;
      if (isStopStep) {
        circleClassName = passedCircleClassName;
        titleClassName = passedTitleClassName;
        subtitleClassName = passedSubtitleClassName;
        CircleIcon = passedCircleIcon;
        circleIconClassName = passedCircleIconClassName;
      } else {
        circleClassName = currentCircleClassName;
        titleClassName = currentTitleClassName;
        subtitleClassName = currentSubtitleClassName;
        CircleIcon = currentCircleIcon;
        circleIconClassName = currentCircleIconClassName;
      }
      break;
    case TimelineItemState.NEXT:
      topLineClassName = nextLineClassName;
      bottomLineClassName = nextLineClassName;
      circleClassName = nextCircleClassName;
      titleClassName = nextTitleClassName;
      subtitleClassName = nextSubtitleClassName;
      CircleIcon = nextCircleIcon;
      circleIconClassName = nextCircleIconClassName;
      break;
  }

  if (isFirst) {
    topLineClassName = classes.firstTopLineClassName;
  }

  if (isLast) {
    bottomLineClassName = classes.lastBottomLineClassName;
  }

  return {
    topLineClassName,
    bottomLineClassName,
    circleClassName,
    titleClassName,
    subtitleClassName,
    CircleIcon,
    circleIconClassName,
  };
};
